// extracted by mini-css-extract-plugin
export default {"f":"_87dcc567c1","main":"_7350d0eb67","btn":"_0fc8f20ab8","w":"_0e8d97a7a8","h":"ce083fe7a2","lh25":"_76489c51b8","wb":"_6a8453bc3f","b":"b070ac090e","bx":"e24c4beef2"};